import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { personas } from "@/constants/LandingSection";
import useAuthStore from "@/shared/zustand/authStore";
import { ArrowRight } from "lucide-react";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import useToastStore from "@/shared/zustand/toastStore";
import { LandingSectionStepper } from "./LandingSection";
import { getCwUserPersona, setCwUserPersona } from "@/core/api/api";
import { Chip } from "primereact/chip";
// const StepOne = ({
//   handleNext,
//   activeStep,
// }: {
//   handleNext: () => void;
//   activeStep: number;
// }) => {
const StepOne = () => {
    const { onboardingStep, setOnboardingStep } = useAuthStore();
    const [loading, setLoading] = useState(false);
    const [selectedPersonas, setSelectedPersonas] = useState([]);
    const user = useAuthStore((state) => state.user);
    const showToast = useToastStore((state) => state.showToast);
    const handlePersonaToggle = (persona) => {
        setSelectedPersonas((prev) => prev.includes(persona)
            ? prev.filter((p) => p !== persona)
            : [...prev, persona]);
    };
    const getPersonnaData = async () => {
        try {
            setLoading(true);
            if (!user?.email) {
                showToast("error", "Error", "User email is not available");
                return;
            }
            const { responseData, error } = await getCwUserPersona(user.email);
            if (error) {
                console.error("Error while getting persona data: ", error);
                showToast("error", "Error", error.errorMessage);
                return;
            }
            if (responseData && responseData?.persona)
                setSelectedPersonas(responseData?.persona);
            // console.log("Persona data:", response.data);
        }
        catch (error) {
            console.error("Error while getting persona data:", error);
            showToast("error", "Error", "There has been an error while getting personna data, check console for more details.");
        }
        finally {
            setLoading(false);
        }
    };
    const sendPersonnaData = async () => {
        try {
            setLoading(true);
            if (!user?.email) {
                showToast("error", "Error", "User email is not available");
                return;
            }
            const { responseData, error } = await setCwUserPersona({
                email: user.provider?.email,
                persona: selectedPersonas,
            });
            if (error) {
                console.error("Error while sending persona data:", error);
                showToast("error", "Error", error.errorMessage);
                return;
            }
            if (responseData) {
                console.log("Personas data successfully sent:", responseData);
                showToast("success", "Success", "Personnas successfully set");
                // handleNext();
                setOnboardingStep("data sources");
            }
            else {
                console.error("Unexpected response:", responseData);
                showToast("error", "Error", "Failed to update user personnas");
            }
        }
        catch (error) {
            console.error("Error while sending persona data:", error);
            showToast("error", "Error", "There has been an error while sending personna data, check console for more details.");
        }
        finally {
            setLoading(false);
        }
    };
    // UseEffect to load the personna data when the component mounts
    useEffect(() => {
        if (user?.email)
            getPersonnaData();
    }, []);
    console.log("onboardingStep in StepOne:", onboardingStep);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-col gap-y-6 h-lg:gap-y-8 px-6 h-lg:px-8 pt-6 h-lg:pt-8 overflow-y-auto", children: [_jsxs("div", { className: "flex flex-col gap-y-2", children: [_jsx("h2", { className: "text-3xl h-lg:text-4xl bg-gradient-to-br from-[#2546F0] to-[#5928ED] bg-clip-text text-transparent font-heading font-semibold", children: "What Creative Workspace.AI can do for you?" }), _jsx("p", { className: "text-sm text-[#667085] font-content", children: "We simplify your creative process by seamlessly integrating tools, data, and AI-driven workflows into one platform. Switch modes effortlessly, collaborate in real time, and bring your ideas to life faster than ever." })] }), _jsx("span", { className: "text-base 2xl:text-lg text-[#1F2937] font-medium font-content", children: "#Let\u2019s Get Started" }), _jsxs("div", { className: "w-full p-6 h-lg:p-8 rounded-[8px] border border-[#e0e0e0] flex flex-col gap-y-5", children: [_jsxs("div", { className: "flex flex-col gap-y-4", children: [_jsx("p", { className: "font-medium text-base", children: "Step 1: Let\u2019s get personal" }), _jsx(LandingSectionStepper, { activeStep: onboardingStep }), _jsx("h3", { className: "text-lg font-medium text-[#222222] mt-4", children: "Select the roles that apply to you" }), _jsx("p", { className: "text-sm lg:text-base text-[#8C8C8C] font-normal", children: "You can select one or multiple based on your role within the organization." })] }), _jsx("div", { className: "flex flex-wrap items-center gap-3", children: personas?.map((persona) => (_jsx(Chip, { label: persona, className: `cursor-pointer px-4 text-sm font-medium transition-all duration-300 ${selectedPersonas.includes(persona)
                                        ? "border border-[#2546f0] bg-[rgba(0,115,230,0.05)] text-[#374151]"
                                        : "border border-[#E0E0E0] bg-transparent text-[#374151]"}`, style: {
                                        transition: "all 0.3s ease",
                                    }, onClick: () => handlePersonaToggle(persona) }, persona))) })] })] }), _jsx("div", { className: "w-full flex justify-end items-center px-6 h-lg:px-8 pt-6 pb-6 h-lg:pb-8 border-t border-[#E7E5EB]", children: _jsxs(Button, { disabled: selectedPersonas.length < 1, loading: loading, type: "button", className: "rounded-[6px] px-4 py-2 text-xl text-white flex items-center gap-x-2 transition-all duration-300 bg-gradient-to-r from-[#2546F0] to-[#5928ED] hover:from-[#0039cc] hover:to-[#0039cc]", onClick: () => sendPersonnaData(), children: [_jsx("span", { className: "ml-2", children: "Next" }), _jsx("div", { className: "ml-3", children: _jsx(ArrowRight, {}) })] }) })] }));
};
export default StepOne;
